import { Box, Checkbox, TextField, Tooltip } from "@mui/material";
import { Autocomplete } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";

import moment from "moment";

import { useAuth } from "oidc-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/pro-duotone-svg-icons";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import "dayjs/locale/en";
import { Popper } from "@mui/base";

import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { WeekColor } from "../../../_helper/helper";

function TableRowsVerificationUpload({
  rowsData,
  handleChange,
  handleDateFieldChange,
  setTimeTo,
  setRowsData,
  payPeriod,
  handleVerifyRows,
  dateFormats,
  inputFormat,
  prevUsers,
  checkJobNumberExist,
}) {

  const StatusReturn = (item) => {
    const statusList = [];
				if (item.timekeeper_Status == "Approved") statusList.push(<Tooltip title={`Timekeeper - ${item.timekeeper_name ? item.timekeeper_name: "Approved"}`} arrow placement='left'>
					<span style={{ borderRadius: "50%", background: "green", color: "white", fontSize: '12px', padding: "1px 9px 1px 9px", margin: "0px 0.3rem", display: 'inline-block' }}>{"T"}</span>
				</Tooltip>)
				if (item.timekeeper_Status == "Rejected") statusList.push(<Tooltip title={`Timekeeper - ${item.timekeeper_name ? item.timekeeper_name : "Rejected"}`} arrow placement='left'>
					<span style={{ borderRadius: "50%", background: "red", color: "white", fontSize: '12px', padding: "1px 9px 1px 9px", margin: "0px 0.3rem", display: 'inline-block' }}>{"T"}</span>
				</Tooltip>)
				if (item.supervisor_Status == "Approved") statusList.push(<Tooltip title={`Supervisor - ${item.supervisor_name ? item.supervisor_name : "Approved"}`} arrow placement='left'>
					<span style={{ borderRadius: "50%", background: "green", color: "white", fontSize: '12px', padding: "1px 9px 1px 9px", margin: "0px 0.3rem", display: 'inline-block' }}>{"S"}</span>
				</Tooltip>)
				if (item.supervisor_Status == "Rejected") statusList.push(<Tooltip title={`Supervisor - ${item.supervisor_name ? item.supervisor_name : "Rejected"}`} arrow placement='left'>
					<span style={{ borderRadius: "50%", background: "red", color: "white", fontSize: '12px', padding: "1px 9px 1px 9px", margin: "0px 0.3rem", display: 'inline-block' }}>{"S"}</span>
				</Tooltip>)
				if (item.certifyingOfficer_Status == "Approved") statusList.push(<Tooltip title={`Certifying Officer - ${item.certifyingOfficer_name ? item.certifyingOfficer_name : "Approved"}`} arrow placement='left'>
					<span style={{ borderRadius: "50%", background: "red", color: "white", fontSize: '12px', padding: "1px 9px 1px 9px", margin: "0px 0.3rem", display: 'inline-block' }}>{"C"}</span>
				</Tooltip>);
				if (item.certifyingOfficer_Status == "Rejected") statusList.push(<Tooltip title={`Certifying Officer - ${item.certifyingOfficer_name ? item.certifyingOfficer_name : "Rejected"}`} arrow placement='left'>
					<span style={{ borderRadius: "50%", background: "green", color: "white", fontSize: '12px', padding: "1px 9px 1px 9px", margin: "0px 0.3rem", display: 'inline-block' }}>{"C"}</span>
				</Tooltip>);
				if (item.appointingAuthority_Status == "Approved") statusList.push(<Tooltip title={`Agency Director - ${item.appointingAuthority_name ? item.appointingAuthority_name : "Approved"}`} arrow placement='left'>
					<span style={{ borderRadius: "50%", background: "green", color: "white", fontSize: '12px', padding: "1px 9px 1px 9px", margin: "0px 0.3rem", display: 'inline-block' }}>{"A"}</span>
				</Tooltip>);
				if (item.appointingAuthority_Status == "Rejected") statusList.push(<Tooltip title={`Agency Director - ${item.appointingAuthority_name ? item.appointingAuthority_name : "Rejected"}`} arrow placement='left'>
					<span style={{ borderRadius: "50%", background: "red", color: "white", fontSize: '12px', padding: "1px 9px 1px 9px", margin: "0px 0.3rem", display: 'inline-block' }}>{"A"}</span>
				</Tooltip>);
        if (item.payrollTech_Status == "Approved") statusList.push(<Tooltip title={`Payroll Tech - ${item.payrollTech_name ? item.payrollTech_name : "Approved"}`} arrow placement='left'>
        <span style={{ borderRadius: "50%", background: "green", color: "white", fontSize: '12px', padding: "1px 9px 1px 9px", margin: "0px 0.3rem", display: 'inline-block' }}>{"P"}</span>
      </Tooltip>);
      if (item.payrollTech_Status == "Rejected") statusList.push(<Tooltip title={`Payroll Tech - ${item.payrollTech_name ? item.payrollTech_name : "Rejected"}`} arrow placement='left'>
        <span style={{ borderRadius: "50%", background: "red", color: "white", fontSize: '12px', padding: "1px 9px 1px 9px", margin: "0px 0.3rem", display: 'inline-block' }}>{"P"}</span>
      </Tooltip>);
				// if (item.certifyingOfficer_Status == null) statusList.push("")
				// if (item.appointingAuthority_Status == null) statusList.push("")
				// if (item.supervisor_Status == null) statusList.push("")
				// if (item.payrollTech_Status == null) statusList.push("") 
				// if (item.timekeeper_Status == null) statusList.push("") 
        
				 return statusList 
  }
  function renderTextInput(value, stateName, label, others = {}) {
    let other = {
      disabled: true,
      maxLength: "",
      multiline: false,
      required: false,
      shrink: true,
      width: null,
      ...others,
    };
    let { disabled, maxLength, multiline, required, shrink, width } = other;

    return (
      <TextField
        fullWidth
        size="small"
        inputProps={{
          style: {
            fontSize: "14px",
            paddingTop: "12px",
            width: width || "100%",
          },
          maxLength: maxLength,
          readOnly: disabled,
        }}
        margin="dense"
        variant="outlined"
        label={label}
        name={stateName}
        id={stateName}
        multiline={multiline}
        rows={multiline ? 3 : 1}
        value={value}
        InputLabelProps={{ shrink: shrink ? shrink : false }}
        shrink={shrink ? shrink : false}
      />
    );
  }

  const [leaveName, setLeavename] = useState("");

  return (
    <>
      {" "}
      {rowsData?.length
        ? rowsData?.map((data, index) => {
            const {
              ID,
              jobtype,
              date,
              time_from,
              time_to,
              hrs,
              jobOrder,
              ole1,
              dateExceed1,
              authError1,
              leaveHours,
              approvedStatus,
              verify,
              sameRate,
            } = data;
            const inputProps = {
              style: { fontSize: 14, step: 300 },
              step: 300,
            };

            const styles = (theme) => ({
              popper: {
                width: "fit-content",
              },
            });
            const PopperAutocomplete = function (props) {
              return (
                <Popper
                  {...props}
                  style={styles.popper}
                  placement="bottom-start"
                />
              );
            };

            const weekColors = WeekColor(
              payPeriod?.StartDate,
              payPeriod?.EndDate,
              date,
              jobtype,
              null,
              sameRate
            );
            return (
              <>
                <Fragment key={`x${index}`} className="trRow1">
                  {sameRate}
                  <tr
                    key={index}
                    bordercolor="red"
                    className="trRow1"
                    style={{
                      marginBottom: 0,
                      marginTop: 0,
                      // backgroundColor: getDateColor(date, rowsData),
                    }}
                  >
                    <td
                      className="paroll-contents-td"
                      style={{
                        backgroundColor: `${weekColors}`,
                        width: "180px",
                      }}
                    >
                      {renderTextInput(jobtype)}
                    </td>
                    <td
                      className="paroll-contents-td"
                      style={{
                        backgroundColor: `${weekColors}`,
                        width: "180px",
                      }}
                    >
                      {renderTextInput(date)}
                    </td>
                    <td
                      className="paroll-contents-td"
                      style={{
                        backgroundColor: `${weekColors}`,
                        width: "180px",
                      }}
                    >
                      {renderTextInput(time_from)}
                    </td>
                    <td
                      className="paroll-contents-td"
                      style={{
                        backgroundColor: `${weekColors}`,
                        width: "180px",
                      }}
                    >
                      {renderTextInput(time_to)}
                    </td>
                    <td
                      className="paroll-contents-td"
                      style={{
                        backgroundColor: `${weekColors}`,
                        width: "180px",
                      }}
                    >
                      {renderTextInput(hrs)}
                    </td>
                    <td
                      className="paroll-contents-td"
                      style={{
                        backgroundColor: `${weekColors}`,
                        width: "180px",
                        padding:"16px"
                      }}
                    >
                     {StatusReturn(data)}
                    </td>
                    <td
                      className="paroll-contents-td"
                      style={{
                        backgroundColor: `${weekColors}`,
                        width: "180px",
                      }}
                    >
                      {renderTextInput(jobOrder)}
                    </td>
                  </tr>
                </Fragment>
              </>
            );
          })
        : null}
    </>
  );
}

export default TableRowsVerificationUpload;
